var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-size-h2 text-footer"},[_vm._v("SITE DOES NOT EXIST.")])
}
var staticRenderFns = []

export { render, staticRenderFns }